import type { OfferPageFilterType } from 'contexts/OfferPage/offerPageStateReducer'

export const mobileRoomTestCalendarFilters: Array<OfferPageFilterType> = ['airport', 'duration', 'capacity', 'flights-toggle', 'room']
